var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 33,
    viewBox: "0 0 70 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7395 18.8347V3.14951C47.7395 2.27694 48.4975 1.44336 49.3694 1.44336H49.4803C49.5102 1.44336 49.5372 1.44936 49.5672 1.45235L49.5731 1.44336H62.6872C64.5837 1.44336 65.3208 2.80468 66.0069 3.81517C67.463 5.9591 68.9461 9.68624 68.973 13.5003V13.4733L69 25.7312H1.00001V18.8347H47.7395Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9376 2.94336V10.3946C48.9376 10.3946 54.2048 12.9404 67.5615 14.7245C67.5615 14.7245 67.5465 5.94186 63.1632 2.94336H48.9376Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5997 26.0543C48.5997 28.8639 50.8768 31.1458 53.6841 31.1458C56.4915 31.1458 58.7686 28.8669 58.7686 26.0543C58.7686 23.2418 56.4915 20.9629 53.6841 20.9629C50.8768 20.9629 48.5997 23.2418 48.5997 26.0543Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3827 26.0534C50.3827 27.8795 51.8628 29.3608 53.6875 29.3608C55.5121 29.3608 56.9922 27.8795 56.9922 26.0534C56.9922 24.2274 55.5121 22.7461 53.6875 22.7461C51.8628 22.7461 50.3827 24.2274 50.3827 26.0534Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7199 26.0534C52.7199 26.5871 53.1514 27.0189 53.6847 27.0189C54.218 27.0189 54.6494 26.5871 54.6494 26.0534C54.6494 25.5197 54.218 25.0879 53.6847 25.0879C53.1514 25.0879 52.7199 25.5197 52.7199 26.0534Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52738 26.0543C6.52738 28.8639 8.80444 31.1458 11.6148 31.1458C14.4252 31.1458 16.6992 28.8669 16.6992 26.0543C16.6992 23.2418 14.4222 20.9629 11.6148 20.9629C8.80743 20.9629 6.52738 23.2418 6.52738 26.0543Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27576 28.3953C7.98518 27.1037 7.98518 25.0096 9.27575 23.718C10.5663 22.4264 12.6588 22.4264 13.9493 23.718C15.2399 25.0096 15.2399 27.1037 13.9493 28.3953C12.6588 29.6869 10.5663 29.6869 9.27576 28.3953Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6476 26.0534C10.6476 26.5871 11.0791 27.0189 11.6124 27.0189C12.1457 27.0189 12.5771 26.5871 12.5771 26.0534C12.5771 25.5197 12.1457 25.0879 11.6124 25.0879C11.0791 25.0879 10.6476 25.5197 10.6476 26.0534Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4883 26.0543C18.4883 28.8639 20.7654 31.1458 23.5757 31.1458C26.3861 31.1458 28.6602 28.8669 28.6602 26.0543C28.6602 23.2418 26.3831 20.9629 23.5757 20.9629C20.7684 20.9629 18.4883 23.2418 18.4883 26.0543Z",
    fill: "#868686",
    stroke: "#272727",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2714 26.0534C20.2714 27.8795 21.7515 29.3608 23.5761 29.3608C25.4008 29.3608 26.8809 27.8795 26.8809 26.0534C26.8809 24.2274 25.4008 22.7461 23.5761 22.7461C21.7515 22.7461 20.2714 24.2274 20.2714 26.0534Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6115 26.0534C22.6115 26.5871 23.043 27.0189 23.5763 27.0189C24.1096 27.0189 24.541 26.5871 24.541 26.0534C24.541 25.5197 24.1096 25.0879 23.5763 25.0879C23.043 25.0879 22.6115 25.5197 22.6115 26.0534Z",
    fill: "#272727",
    stroke: "#868686",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.911 23.332C65.5455 23.332 65.2458 23.5659 65.2458 23.9317C65.2458 24.2975 65.5425 24.5314 65.911 24.5314H67.1903C67.5559 24.5314 67.8555 24.2975 67.8555 23.9317C67.8555 23.5659 67.5589 23.332 67.1903 23.332H65.911Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78891 23.332C2.42339 23.332 2.12377 23.5659 2.12377 23.9317C2.12377 24.2975 2.42039 24.5314 2.78891 24.5314H4.06826C4.43379 24.5314 4.7334 24.2975 4.7334 23.9317C4.7334 23.5659 4.43678 23.332 4.06826 23.332H2.78891Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6307 2.64258H55.8291V12.5376H54.6307V2.64258Z",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11732 1.44336H45.0008C45.7379 1.44336 46.2412 2.18399 46.2412 2.92162V17.3354H0.99976V2.92162C0.99976 2.18699 1.38326 1.44336 2.12031 1.44336H2.11732Z",
    fill: "#868686"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 32,
    fill: "white",
    transform: "matrix(-1 0 0 1 70 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD2);
export default __webpack_public_path__ + "static/media/d2.18eaef8a920aa48a2653e89fc93b3a02.svg";
export { ForwardRef as ReactComponent };